jQuery(document).ready(() => {
  $('.submit-reset-pass').click(function (event) {
    $(this).parent().parent().find('form')
        .submit();
    event.preventDefault();
  });

  $('#password-recovery, #password-recovery').submit(function (event) {
    $(this).find('input[name=recovery-email]').addClass('spinner');
    $('#passwordRecovery').find('#submit-recovery, .btn-login').hide();
    $('#passwordRecovery').find('.gif-loader').show();
    $(this).find('.recovery-error').hide();
    $(this).find('.recovery-success').hide();
    $('.help-block').remove();
    $('#password-recovery .form-group').removeClass('has-error');

    const data 	= $(this).serialize();
    const frmRfc	= $(this);

    $.ajax({
      url: urlPasswordRecovery,
      type: 'POST',
      dataType: 'json',
      async: true,
      data,
      success(data) {
        frmRfc.find('input[name=recovery-email]').removeClass('spinner');
        $('#passwordRecovery').find('#submit-recovery, .btn-login').show();
        $('#passwordRecovery').find('.gif-loader').hide();
        $('#passwordRecovery .captcha-div').find('input[name="captcha[id]"]').val(data.captcha.id);
        $('#passwordRecovery .captcha-div').find('input[name="captcha[input]"]').val('');
        $('#passwordRecovery .captcha-div').find('img').attr('src', data.captcha.src);

        if (data.success) {
          frmRfc.find('.recovery-success').show();
          $('#passwordRecovery .captcha-div').find('input[name="recovery-email"]').val('');
        } else if (data.formErrors && data.formErrors.length !== 0) {
          $.each(data.formErrors, (elementId, value) => {
            if (elementId == 'captcha') {
              $.each(value, (index, value) => {
                $('#password-recovery').find('.captcha-input').parent().addClass('has-error');
                $('#password-recovery').find('.captcha-input').parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
              });
            } else {
              $.each(value, (index, value) => {
                $('#password-recovery').find(`[name="${elementId}"]`).parent().addClass('has-error');
                $('#password-recovery').find(`[name="${elementId}"]`).parent().append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
              });
            }
          });
        } else {
          frmRfc.find('.recovery-error').show();
        }
      },
      error(data) {
        frmRfc.find('input[name=recovery-email]').removeClass('spinner');
        $('#passwordRecovery').find('#submit-recovery, .btn-login').show();
        $('#passwordRecovery').find('.gif-loader').hide();
      }
    });

    event.preventDefault();
  });

  $('#lsoModal, #passwordRecovery').on('hidden.bs.modal', (e) => {
    $('.recovery-success').hide();
    $('.recovery-error').hide();
    $('input[name=recovery-email]').val('');
  });

  $('#showhide').on('click', function () {
    const btn = $(this);
    if (btn.val() == 'show') {
      btn.val('hide');
      $("input[name='password'], input[name='re-password']").attr('type', 'text');
    } else {
      btn.val('show');
      $("input[name='password'], input[name='re-password']").attr('type', 'password');
    }
  });
});
